import classes from './Banner.module.scss';
import ContactInfo from "../../GlobalComponents/ContactInfo/ContactInfo";
import Form from '../Form/Form';

const Banner = () => {
    return (
        <section className={classes.bannerWrap}>
            <div className="container">
                <div className={classes.banner}>
                    <div className={classes.col}>
                        <Form />
                    </div>
                    <div className={classes.col}>
                        <div className={classes.contactInfoWrap}>
                            <ContactInfo />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Banner;
